import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@platform/witems';
import { QueryClientProvider } from '@tanstack/react-query';
import '@platform/witems/dist/index.css';
import './styles/global.css';
import App from './App';
import { cleanupLegacyAI } from './logic/highlights/cleanupLegacyAI';
import { wsInit } from './lib/wiservice';
import { queryClient } from './state/data/_shared/queryClient';

cleanupLegacyAI();

// Configure @platform/wiservice once before the first render so the auth
// store's mount-time `init()` (via useAuth) finds the package fully wired.
// Reads Constants under the hood — must run AFTER the constants module
// resolves but BEFORE React.StrictMode mounts components that call ws().
wsInit();

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider version="v2">
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
